export const adaptTipoServicio = (tipoServicioData) => {
    return {
        id: tipoServicioData?.idTipoServicio,
        displayName: tipoServicioData?.descripcion,
        name: tipoServicioData?.descripcion
    }
}

export const adaptTipoServicioArray = (
    tipoServicios
) => {
    return structuredClone(tipoServicios?.allTipoServicio)
        ?.map(tipoServicio => adaptTipoServicio(tipoServicio));
}